import React, { useState, useEffect } from "react";
import { Modal, ModalBody, Form, Row, Col } from "reactstrap";
import StyledButton from "../../components/Common/StyledButton";
import { createBudget, createEditTaxIdentity, deleteBudget, deleteTaxIdentity, updateBudget } from "../../api";
import { toast } from "react-toastify";

const getFiscalYear = (date = new Date()) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;

    return month < 4 ? year - 1 : year;
}

const getFiscalYearOptions = (value) => {
  const currentFYYear = getFiscalYear();
  const startFYYear = value < currentFYYear ? value : currentFYYear;
  return [
    startFYYear,
    startFYYear + 1,
    startFYYear + 2,
  ];
}

const BudgetModal = ({ clientId, branchId, openModal, setOpenModal, editId = null, values, updateBudgetList, permissions }) => {
  const [fieldType, setFieldType] = useState("");
  const [fieldValue, setFieldValue] = useState("");
  const [fiscalYear, setFiscalYear] = useState(getFiscalYear());
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const notify = (type, message) => {
    if (type === 'Error') {
      toast.error(message, {
        position: 'top-center',
        theme: 'colored',
      });
    } else {
      toast.success(message, {
        position: 'top-center',
        theme: 'colored',
      });
    }
  };

  useEffect(() => {
    if (editId) {
        setFieldType(values.fieldType);
        setFieldValue(values.fieldValue);
        setFiscalYear(values.fiscalYear);
    } else {
      const currentFiscalYear = getFiscalYear();
      setFieldType("");
      setFieldValue("");
      setFiscalYear(currentFiscalYear);
    }
  }, [openModal, editId, values]);

  const createOrEditBudgetModal = async () => {
    setIsButtonLoading(true);

    let response;
    if (editId) {
      response = await updateBudget({
        branchId,
        _id: editId,
        period: fieldType,
        amount: fieldValue,
        fiscalYear,
      });
    } else {
      response = await createBudget({
        clientId,
        branchId,
        period: fieldType,
        amount: fieldValue,
        fiscalYear,
      });
    }

    if (response.success) {
      const budget = response.payload.budget;
      notify("success", response.message);
      updateBudgetList(branchId, budget);
      setIsButtonLoading(false);
      setOpenModal(false);
    } else {
       notify("Error", response.message);
       setIsButtonLoading(false);
       setOpenModal(false);
    }
  }

  const checkFieldChanged = () => {
    if (editId) {
      return fieldType === values.fieldType && fieldValue === values.fieldValue && fiscalYear === values.fiscalYear;
    }
    return false;
  };

  const onDeleteBudget = async () => {
    const response = await deleteBudget(editId);
    if (response.success) {
      notify("success", response.message);
      updateBudgetList(branchId, {_id: editId }, true);
      setOpenModal(false);
    } else {
       notify("Error", response.message);
       setOpenModal(false);
    }
  };

  return (
    <Modal
      size="md"
      centered
      isOpen={openModal}
      toggle={() => setOpenModal(false)}
    >
        <div className="modal-header">
          <h4>{editId ? "Edit Budget Limit" : "Add Budget Limit"}</h4>
          <StyledButton outline color="danger" onClick={() => setOpenModal(false)}>
            Close
          </StyledButton>
        </div>

        <ModalBody>
          <Row>
            <Col className="mt-2">
              <label className="item-name">Fiscal Year</label>
              <select
                className="form-select"
                value={fiscalYear}
                onChange={(e) => {
                  const val = e.target.value;
                  setFiscalYear(val);
                }}
              >
                <option value="">Select Fiscal Year</option>
                {getFiscalYearOptions(values?.fiscalYear).map((year) => (
                  <option key={year} value={year}>
                    FY {year}-{year + 1}
                  </option>
                ))}
              </select>
            </Col>
            <Col className="mt-2">
              <label className="item-name">Select Type</label>
              <select
                className="form-select"
                value={fieldType}
                onChange={(e) => {
                  const val = e.target.value;
                  setFieldType(val);
                  if (!val) {
                    setFieldValue('');
                  }
                }}
              >
                <option value="">Select Type</option>
                <option value="once">Every PO/PR</option>
                <option value="monthly">Monthly</option>
                <option value="quarterly">Quarterly</option>
              </select>
            </Col>
          </Row>

          <Row>
            <Col className="mt-3">
              <label className="item-name">Enter Amount(₹)</label>
              <input
                type="text"
                className="form-control"
                placeholder={'Enter Amount(₹)'}
                value={fieldValue}
                disabled={!fieldType}
                onChange={(e) => {
                  const val = e.target.value;
                    const amount = val.replace(/[^0-9]/g, '');
                    setFieldValue(amount);
                }}
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <StyledButton
                color={"primary"}
                className={"w-md mx-2"}
                onClick={createOrEditBudgetModal}
                isLoading={isButtonLoading}
                disabled={checkFieldChanged() || (!permissions.includes("create") && !editId) || (!permissions.includes("update") && editId)}
              >
                {editId ? "Update" : "Save"}
              </StyledButton>
              {editId && (
                <StyledButton
                  color="danger"
                  className={"w-md mx-2"}
                  onClick={onDeleteBudget}
                  isLoading={isButtonLoading}
                  disabled={!permissions.includes("delete")}
                >
                  Delete
                </StyledButton>
                )}
            </Col>
          </Row>
        </ModalBody>
    </Modal>
  );
};

export default BudgetModal;